import { PerspectiveCamera, Vector3, CatmullRomCurve3 } from "three";

export function createCamera(): PerspectiveCamera {
  const cam = new PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 200);
  cam.position.set(0, 0, 8);
  window.addEventListener("resize", () => {
    cam.aspect = window.innerWidth / window.innerHeight;
    cam.updateProjectionMatrix();
  });
  return cam;
}

export function createCameraPath(): CatmullRomCurve3 {
  return new CatmullRomCurve3([
    new Vector3(0, 0, 8),
    new Vector3(2, 1, 5),
    new Vector3(0, 2, 2),
    new Vector3(-2, 0, -1),
    new Vector3(0, -1, -4),
    new Vector3(0, 0, 14),
  ], false, "catmullrom", 0.3);
}
